var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"roma-page-content fill-height grey lighten-4"},[_c('h2',[_vm._v("Tareas por revisar")]),_c('TaskFilter'),_c('TaskList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }